import { useCustomQuery } from "utilities/hookutils";

export const useTags = (mainArea: server.dto.MainAreas) => {
  const tagsQuery = useCustomQuery({
    queryFn: async () => window.CoreApi.Tag.ListTags(mainArea).then(r => r.data.data),
    queryKey: ["tags", mainArea]
  });

  return tagsQuery;
}

export const useHasAnyTags = (mainArea: server.dto.MainAreas) => {
  const tagsQuery = useTags(mainArea);
  if (tagsQuery.isLoading) {
    return true;
  }
  return tagsQuery.data.length > 0;
}